module.exports = __webpack_public_path__ + "static/media/key.a5d8a069.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/key.svg
// module id = 662
// module chunks = 0